import React from 'react';

import { Box, Typography } from '@mui/material';
import cx from 'classnames';

import ChevronTopIcon from '../../../../assets/icons/ChevronTopIcon';
import { colorsPalette } from '../../../../theme';
import useStyles from './style';

interface FilterItemProps {
  label: string;
  count: number;
  isRefined: boolean;
  value: any;
  refine: Function;
  filterValue: string;
  withArrow?: boolean;
}

const FilterItem: React.FC<FilterItemProps> = React.forwardRef(
  (
    { label, count, isRefined, value, refine, filterValue, withArrow = false },
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const classes = useStyles();
    const checkboxName = `${filterValue}${label}`;

    return (
      <div
        data-testid="filterItem"
        ref={ref}
        className={cx(classes.listItem, isRefined && classes.listItemActive)}
        onClick={() => refine(value)}
      >
        <Box className={classes.leftPart}>
          {withArrow && (
            <ChevronTopIcon
              color={colorsPalette.white}
              className={cx(classes.icon, isRefined && classes.selectedIcon)}
            />
          )}
          <input
            type="checkbox"
            checked={isRefined}
            onChange={() => refine(value)}
            className={classes.checkbox}
            name={checkboxName}
          />
          <label className={classes.checkboxLabel} htmlFor={checkboxName} />
          <Typography className={classes.listItemTitle}>{label}</Typography>
        </Box>
        <Box>
          <Typography className={classes.listItemCount}>({count})</Typography>
        </Box>
      </div>
    );
  },
);

export default FilterItem;
